<p-panel>
    <ng-template pTemplate="header">
        <div class="flex flex-row align-items-center gap-2 w-full">
            <div class="flex"><h4>Appointments</h4></div>
            <div class="flex w-full justify-content-end">
                <p-button *ngIf="encounter && encounter.appointments &&  encounter.appointments.length >= 0" icon="pi pi-history" label="History" [text]="true" (onClick)="appointmentHistoryOp.toggle($event)" ></p-button>
                <p-overlayPanel appendTo="body" #appointmentHistoryOp>
                    <p-table *ngIf="encounter && encounter.appointments" [value]="encounter.appointments">
                        <ng-template pTemplate="header">
                            <tr>
                                <th>Date</th>
                                <th>Provider</th>
                                <th>Status</th>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-appointment>
                            <tr>
                                <td>{{appointment.appointmentDate | date : 'shortDate'}}</td>
                                <td>{{appointment.providerLocation.facility.name}}</td>
                                <td>{{appointment.statusName}}</td>
                            </tr>
                        </ng-template>
                    </p-table>
                </p-overlayPanel>
            </div>      
        </div>
    </ng-template>

    <div class="flex flex-column justify-content-center align-items-center surface-ground h-15rem w-full">
        
        <div class="flex grid w-full">
            <div class="col-3"></div>
            <div class="flex col-6 justify-content-center align-items-center">

                <div *ngIf="displayDate" class="calendar">
                    <span class="dayname">{{appointmentDayName}}</span>
                    <span class="monthname">{{appointmentMonth}} {{appointmentYear}} </span>
                    <span class="datenumber">{{appointmentDay}}</span>
                </div>    
            </div>

            <div *ngIf="completeAppointment" class="col-3 flex align-items-center justify-content-start" >
                <p-button icon="pi pi-check-circle" text></p-button>
            </div>
        </div>
       
        <div *ngIf="appointmentDate && !completeAppointment && !locked" class="flex mt-2">
            <p-button icon="pi pi-ban" text label="Cancel" (onClick)="cancelAppointment()"></p-button>
        </div>

        <div *ngIf=" encounter && encounter.proposedProvider && !appointmentDate && !completeAppointment" class="noappointment justify-content-center align-items-center flex" (click)="newAppointmentOp.toggle($event)">
            <i class="pi pi-plus" pTooltip="New Appointment"></i>
            <p-overlayPanel appendTo="body" #newAppointmentOp>
                <div *ngIf="encounter" class="flex flex-row w-full align-items-center">
                    <div>
                        <p-calendar placeholder="Appointment Date" [minDate]="encounter.encounterCreationDate" (onSelect)="newAppointmentSelected($event)"  ></p-calendar>
                    </div>
                </div>
            </p-overlayPanel>
        </div>

        


    </div>
</p-panel>

